import type { PaletteColor } from "@mui/material";
import type {
  Components,
  PaletteColorOptions,
  Theme,
} from "@mui/material/styles";

import type { ColorName } from "../../options/palette";

declare module "@mui/material" {
  interface ChipPropsVariantOverrides {
    dark: true;
    light: true;
  }
}

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      variants: [
        ...Object.entries(theme.palette)
          .filter(
            ([, values]) => typeof values === "object" && "dark" in values,
          )
          .map(([color, values]: [ColorName, PaletteColor]) => ({
            props: {
              color,
              variant: "dark" as const,
            },
            style: {
              backgroundColor: values.dark,
            },
          })),
        ...Object.entries(theme.palette)
          .filter(
            ([, values]) => typeof values === "object" && "light" in values,
          )
          .map(
            ([color, values]: [
              ColorName,
              PaletteColorOptions & PaletteColor,
            ]) => ({
              props: {
                color,
                variant: "light" as const,
              },
              style: {
                backgroundColor: values.light,
                color:
                  ("A700" in values ? values.A700 : undefined) ?? values.dark,

                "&.Mui-disabled": {
                  color: theme.palette.text.secondary,
                  opacity: 1,
                },

                "&:not(.Mui-disabled) .MuiChip-icon": {
                  color: values.dark,
                },
              },
            }),
          ),
      ],
    }),

    sizeSmall: ({ theme }) => ({
      fontSize: theme.spacing(1.5),
    }),
  },
};
